import React from 'react';

const TermsConditionsSection = () => (
  <section id="terms-conditions" className="relative z-10 -mt-16 md:-mt-24 pb-24 px-4">
    <div className="max-w-5xl mx-auto bg-white border border-[#f4e7da] shadow-[0_25px_65px_rgba(16,24,40,0.08)] rounded-[22px] overflow-hidden">
      <div className="px-6 md:px-12 py-12 md:py-16 space-y-10 text-[#504f4c] leading-relaxed">

        <div className="space-y-6">
          <p>
            Welcome to our website. By continuing to browse or use this site, you agree to be bound by the terms and conditions set out below, along with our Privacy Policy, which together govern Testa Care's relationship with you in connection to this website.
          </p>
          <p>
            If you do not accept any part of these terms, please discontinue use of our website.
          </p>
          <p>
            The term "Testa Care", "we", "us", or "our" refers to the website owner:
          </p>
          <div className="bg-[#fdf5ed] p-6 rounded-lg border border-[#f4e7da]">
            <p className="font-semibold text-[#0d0d0d]">Testa Care</p>
            <p>Sigma Universal Ltd</p>
            <p>Davyfield Road</p>
            <p>Blackburn</p>
            <p>Lancashire</p>
            <p>England</p>
            <p>BB1 2QY</p>
            <p className="mt-2">Email: <a href="mailto:Info@testacare.co.uk" className="text-[#c46422] underline hover:text-[#8a3c11]">Info@testacare.co.uk</a></p>
          </div>
          <p>
            The term "you" refers to the visitor or user of this website.
          </p>
        </div>

        <div className="space-y-6">
          <h2
            className="text-3xl md:text-4xl font-light text-[#0d0d0d]"
            style={{ fontFamily: "'Playfair Display', 'Times New Roman', serif" }}
          >
            Conditions of Use
          </h2>
          <p>
            Use of this website is subject to the following terms:
          </p>
          <ul className="list-disc pl-6 space-y-3">
            <li>The information provided across this site is for general guidance and reference only. Content may be updated or amended at any time without notice.</li>
            <li>This website uses cookies to analyse browsing behaviour and support functionality.</li>
            <li>We do not guarantee the accuracy, completeness, reliability, suitability or timeliness of the content available on this website. You acknowledge that such material may contain errors or inaccuracies, and we exclude liability for these to the fullest extent permitted by law.</li>
            <li>Any use of information from this website is entirely at your own risk. It is your responsibility to ensure that any services, information or materials accessed through this website meet your specific needs.</li>
            <li>The design, layout, content, text, graphics and other materials on this site are owned by or licensed to us. Reproduction is not permitted unless in accordance with our copyright notice.</li>
            <li>Any trademarks reproduced on this website that are not owned by or licensed to us are acknowledged accordingly.</li>
            <li>Unauthorised use of this website may result in a claim for damages and/or be considered a criminal offence.</li>
            <li>From time to time, our website may include links to other sites. These links are provided for convenience and do not signify endorsement. We accept no responsibility for the content of any linked sites.</li>
            <li>Use of this website and any related disputes are governed by the laws of England.</li>
          </ul>
        </div>

        <div className="space-y-6">
          <h2
            className="text-3xl md:text-4xl font-light text-[#0d0d0d]"
            style={{ fontFamily: "'Playfair Display', 'Times New Roman', serif" }}
          >
            Cookie Policy for Testa Care
          </h2>
          <p>
            This Cookie Policy applies to Testa Care and is accessible via our website.
          </p>

          <h3 className="text-2xl font-light text-[#c46422]">What are cookies?</h3>
          <p>
            Like most professional websites, our site uses cookies—small data files stored on your device to improve your browsing experience. This section explains what information cookies collect, how we use them, and why they may be necessary.
          </p>
          <p>
            Preventing cookies may impact website performance or cause certain features to stop working.
          </p>
          <p>
            For general information on cookies, you may refer to online resources such as the Wikipedia article on HTTP Cookies.
          </p>

          <h3 className="text-2xl font-light text-[#c46422]">How we use cookies</h3>
          <p>
            We use cookies for several reasons outlined below. In many cases there are no standard methods to disable cookies without affecting site functionality. If you are unsure whether you need cookies enabled, it is recommended to keep them active to ensure the site works as intended.
          </p>

          <h3 className="text-2xl font-light text-[#c46422]">Disabling cookies</h3>
          <p>
            You can disable cookies by adjusting your browser settings (consult your browser's help documentation for guidance).
          </p>
          <p>
            Please note: disabling cookies may affect the functionality of this website and others you visit. Many interactive features may no longer work correctly.
          </p>

          <h3 className="text-2xl font-light text-[#c46422]">Cookies we set (First-party cookies)</h3>
          <p>
            When you submit information to us—such as through a contact form—cookies may be used to save your details for future correspondence or to improve form performance.
          </p>

          <h3 className="text-2xl font-light text-[#c46422]">Third-party cookies</h3>
          <p>
            We may also use cookies provided by trusted external partners. Examples include:
          </p>

          <div className="bg-[#fdf5ed] p-6 rounded-lg border border-[#f4e7da] space-y-4">
            <h4 className="font-semibold text-[#0d0d0d]">Google Analytics</h4>
            <p>
              We use Google Analytics to understand how visitors use our website. These cookies may track metrics such as:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Time spent on the website</li>
              <li>Pages visited</li>
              <li>User navigation patterns</li>
            </ul>
            <p>
              This helps us improve content and user experience.
            </p>
            <p>
              You can learn more about Google Analytics cookies on their official documentation.
            </p>
          </div>

          <div className="bg-[#fdf5ed] p-6 rounded-lg border border-[#f4e7da] space-y-4">
            <h4 className="font-semibold text-[#0d0d0d]">Feature Testing</h4>
            <p>
              Occasionally, we may test new website features. Cookies may be used to ensure you receive consistent experiences during testing and to help us understand which updates users prefer.
            </p>
          </div>
        </div>

        <div className="space-y-6">
          <h2
            className="text-3xl md:text-4xl font-light text-[#0d0d0d]"
            style={{ fontFamily: "'Playfair Display', 'Times New Roman', serif" }}
          >
            More Information
          </h2>
          <p>
            We hope this policy clarifies how cookies are used on our website. If you are unsure whether you require certain cookies, it is usually best to leave them enabled to ensure all features function properly.
          </p>
          <p>
            For further information, please contact us at: <a href="mailto:Info@testacare.co.uk" className="text-[#c46422] underline hover:text-[#8a3c11]">Info@testacare.co.uk</a>
          </p>
        </div>

        <p className="pt-6 border-t border-[#f1e3d6] text-sm tracking-[0.2em] uppercase text-[#a25421]">
          Updated: 23-07-2024
        </p>
      </div>
    </div>
  </section>
);

export default TermsConditionsSection;
